import React from 'react'
import { ReactSVG } from 'react-svg'
import Dropdown from './Dropdown'
import Avatar from './Avatar'
import Card from './Card'
import UserShortInfo from './UserShortInfo'
import Navigation from './Navigation'
import Btn from './Btn'
import { AuthStore } from '../store/authStore'
import { UserStore } from '../store/userStore'
import { observer } from 'mobx-react-lite'
import { Link } from 'react-router-dom'
import { NotificationsStore } from '../store/notificationsStore'

const Header = observer(() => {
  const headerRef = React.useRef<HTMLElement>(null)

  React.useEffect(() => {
    const header = headerRef.current
    const resizeHandler = (): void => {
      if (header) {
        document.documentElement.style.setProperty(
          '--header-height',
          `${header.offsetHeight}px`
        )
      }
    }

    resizeHandler()
    window.addEventListener('resize', resizeHandler)

    return (): void => {
      window.removeEventListener('resize', resizeHandler)
    }
  }, [])

  return (
    <header ref={headerRef} className="header">
      <div className="container">
        <div className="header__inner">
          <div id="header-portal"></div>
          <Link to={'/'} className={'d-block'}>
            <ReactSVG
              wrapper={'span'}
              src={'/i/logo-sm.svg'}
              className={'header__logo'}
            ></ReactSVG>
          </Link>

          <div className="header__controls">
            <Link
              className={'notifications-control'}
              to={'/notifications'}
              aria-label={'Уведомления'}
            >
              <ReactSVG
                wrapper={'span'}
                src={'/i/svg/bell.svg'}
                className={'notifications-control__icon svg-icon'}
              ></ReactSVG>
              {NotificationsStore.count > 0 && (
                <span className="notifications-control__count">
                  {NotificationsStore.count}
                </span>
              )}
            </Link>
            <Dropdown
              trigger={(open) => (
                <button
                  type={'button'}
                  aria-label={'toggle menu'}
                  onClick={open}
                  className={'header__avatar'}
                >
                  <Avatar url={UserStore.data.avatarUrl} size={'sm'} />
                </button>
              )}
              render={(close) => (
                <Card className={'header-dropdown-card'} shadow>
                  <UserShortInfo small></UserShortInfo>
                  <Navigation onClick={close}></Navigation>
                  <div>
                    <Btn onClick={close} small text to={'/profile'}>
                      Профиль
                    </Btn>
                    <Btn onClick={close} small text to={'/profile/edit'}>
                      Редактирование профиля
                    </Btn>
                    <Btn
                      small
                      target={'_blank'}
                      rel={'noopener noreferrer'}
                      href={'https://goup.guap.ru/'}
                      text
                    >
                      <span>Сайт Орбита</span>
                    </Btn>
                  </div>
                  <div>
                    <Btn
                      small
                      text
                      onClick={async () => {
                        await close()
                        void AuthStore.logout()
                      }}
                    >
                      <ReactSVG
                        src={'/i/svg/icon-left.svg'}
                        wrapper={'span'}
                      ></ReactSVG>
                      <span>Выйти</span>
                    </Btn>
                  </div>
                </Card>
              )}
            ></Dropdown>
          </div>
        </div>
      </div>
    </header>
  )
})

export default Header
